import { render, staticRenderFns } from "./DrawingRequestShowDetails.vue?vue&type=template&id=5b1950bf&"
import script from "./DrawingRequestShowDetails.vue?vue&type=script&lang=js&"
export * from "./DrawingRequestShowDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports